import get from '@invitato/helpers/dist/getLocale';

export default {
  subTitle: get(
    'Abadikan momen Anda selama menghadiri acara pernikahan kami dengan menggunakan filter instagram di bawah:',
    'Capture your moment while attending our wedding by using the Instagram filter below:'),
  textButton: get('Gunakan Filter', 'Use Filter'),
};